import styled from "styled-components";

export const AuthorsLoadingSkeletonContainer = styled.div`
  display: flex;
  gap: 32px;
  margin: 0 0 40px 20px;

  @media (min-width: 600px) {
    margin: 0 0 40px 55px;
  }

  > div {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;

    .circle > div {
      @media (max-width: 850px) {
        width: 120px;
        height: 120px;
      }
    }
  }
`;
